import { render, staticRenderFns } from "./SwapRequestsPending.vue?vue&type=template&id=2d2eff2e"
import script from "./SwapRequestsPending.vue?vue&type=script&lang=js"
export * from "./SwapRequestsPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports